export function getData() {
  return {
    companies: JSON.parse(localStorage.getItem('@FARM/session:companies')),
    branches: JSON.parse(localStorage.getItem('@FARM/session:branches')),
    contract: JSON.parse(localStorage.getItem('@FARM/session:contract')),
    signed: JSON.parse(localStorage.getItem('@FARM/session:signed')),
    user: JSON.parse(localStorage.getItem('@FARM/session:user')),
    token: JSON.parse(localStorage.getItem('@FARM/session:token')),
    logged_branch: JSON.parse(localStorage.getItem('@FARM/session:logged_branch')), // prettier-ignore
    current_accesses: JSON.parse(localStorage.getItem('@FARM/session:current_accesses')), // prettier-ignore
    sectorSelected: JSON.parse(localStorage.getItem('@FARM/session:sectorSelected')), // prettier-ignore
    updateRefreshToken: JSON.parse(localStorage.getItem('@farm/handlenewRefreshToken')), // prettier-ignore
  };
}

export function setData(newData) {
  if (newData.companies) localStorage.setItem('@FARM/session:companies', JSON.stringify(newData.companies)); // prettier-ignore
  if (newData.branches) localStorage.setItem('@FARM/session:branches', JSON.stringify(newData.branches)); // prettier-ignore
  if (newData.contract) localStorage.setItem('@FARM/session:contract', JSON.stringify(newData.contract)); // prettier-ignore
  if (newData.signed || newData.signed === false) localStorage.setItem('@FARM/session:signed', JSON.stringify(newData.signed)); // prettier-ignore
  if (newData.user) localStorage.setItem('@FARM/session:user', JSON.stringify(newData.user)); // prettier-ignore
  if (newData.token) localStorage.setItem('@FARM/session:token', JSON.stringify(newData.token)); // prettier-ignore
  if (newData.logged_branch) localStorage.setItem('@FARM/session:logged_branch', JSON.stringify(newData.logged_branch)); // prettier-ignore
  if (newData.current_accesses) localStorage.setItem('@FARM/session:current_accesses', JSON.stringify(newData.current_accesses)); // prettier-ignore
  if (newData.sectorSelected) localStorage.setItem('@FARM/session:sectorSelected', JSON.stringify(newData.sectorSelected)); // prettier-ignore
}
